import React from 'react';

import Input from '../../../common2/Input';

function WeightInput(props) {
  return <Input {...props} placeholder="0.0" rightElement="kg" />;
}

export default React.memo(WeightInput);
